/**
 * markdown-it plugin to render [[wikilinks]] as clickable links
 */

export default function markdownItWikilink(md) {
  // Add inline rule for wikilinks
  md.inline.ruler.push('wikilink', (state, silent) => {
    const max = state.posMax;
    const start = state.pos;

    // Check for opening [[
    if (state.src.charCodeAt(start) !== 0x5B /* [ */ ||
        state.src.charCodeAt(start + 1) !== 0x5B /* [ */) {
      return false;
    }

    // Find closing ]]
    let pos = start + 2;
    let found = false;
    while (pos < max - 1) {
      if (state.src.charCodeAt(pos) === 0x5D /* ] */ &&
          state.src.charCodeAt(pos + 1) === 0x5D /* ] */) {
        found = true;
        break;
      }
      pos++;
    }

    if (!found) {
      return false;
    }

    const linkText = state.src.slice(start + 2, pos).trim();
    if (!linkText) {
      return false;
    }

    if (!silent) {
      const token = state.push('wikilink', '', 0);
      token.content = linkText;
      token.markup = '[[]]';
    }

    state.pos = pos + 2;
    return true;
  });

  // Render wikilink tokens
  md.renderer.rules.wikilink = (tokens, idx) => {
    const linkText = tokens[idx].content;
    // Render as a special link with data attribute for navigation
    return `<a class="wikilink" data-wikilink="${md.utils.escapeHtml(linkText)}" href="javascript:void(0)">${md.utils.escapeHtml(linkText)}</a>`;
  };
}
